export default __webpack_public_path__ + "static/media/locks-pattern.71c76d93.png";